import { useMemo, useState } from "react";
import SEO from "@/components/SEO";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { PackageCard } from "@/components/Cards";
import { useContent } from "@/lib/content";

const DURATIONS = [
  { label: "3–5 Days", test: (p) => p.days <= 5 },
  { label: "6–8 Days", test: (p) => p.days >= 6 && p.days <= 8 },
  { label: "9+ Days", test: (p) => p.days >= 9 },
];

export default function CategoryPackages({ match, title, overline, description, image, seoTitle, seoDesc, testid, showDurationFilter = false }) {
  const { packages, loading } = useContent();
  const [duration, setDuration] = useState(null);

  const list = useMemo(() => {
    let l = packages.filter(match);
    if (duration) l = l.filter(duration.test);
    return l;
  }, [packages, match, duration]);

  return (
    <div data-testid={testid}>
      <SEO title={seoTitle} description={seoDesc} />
      <PageHero image={image} overline={overline} title={title} description={description} />
      <section className="py-14 lg:py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          {showDurationFilter && (
            <div className="flex flex-wrap gap-2" data-testid="duration-filters">
              <button onClick={() => setDuration(null)} data-testid="duration-filter-all"
                      className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors ${!duration ? "bg-navy text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-royal hover:text-royal"}`}>
                All Durations
              </button>
              {DURATIONS.map((d) => (
                <button key={d.label} onClick={() => setDuration(d)} data-testid={`duration-filter-${d.label.replace(/[^a-z0-9]/gi, "-").toLowerCase()}`}
                        className={`rounded-full px-5 py-2 text-sm font-semibold transition-colors ${duration?.label === d.label ? "bg-navy text-white" : "bg-white border border-slate-200 text-slate-600 hover:border-royal hover:text-royal"}`}>
                  {d.label}
                </button>
              ))}
            </div>
          )}
          <p className="mt-6 text-sm text-slate-500">Starting prices are tentative (per person, twin sharing) — your final quote is customised to dates, hotel category and traveller count.</p>
          {loading ? (
            <p className="mt-10 text-slate-400">Loading packages...</p>
          ) : list.length === 0 ? (
            <p className="mt-10 text-slate-500" data-testid="category-empty">No packages match this filter right now — send us an enquiry and we will craft one for you.</p>
          ) : (
            <div className="mt-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
              {list.map((p, i) => <Reveal key={p.slug} delay={(i % 3) * 0.06}><PackageCard pkg={p} /></Reveal>)}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
